

import iconUser from "src/Assets/iconography/user-heart.svg";

export const notificationTypes = {
    '10_MINS_TO_START' : {
        'title': 'Sesión en 10 minutos',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'CANCELLED_SESSION_FROM_COACH' : {
        'title': 'Tu Coach ha cancelado una sesión',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'CANCELLED_SESSION_FROM_CLIENT' : {
        'title': 'Tu Cliente ha cencelado una sesión',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'DAY_MEMORANDUM' : {
        'title': 'Un nuevo memorandum para el día de hoy',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'CLIENT_INVITATION_ACEPTED' : {
        'title': 'Un Cliente ha aceptado tu invitación',
        'icon' : iconUser,
        'btn_text': 'Ver cliente'
    },
    'MEMBER_INVITATION_ACEPTED' : {
        'title': 'Un Miembro de grupo ha aceptado tu invitación',
        'icon' : iconUser,
        'btn_text': 'Ver grupo'
    },
    'NEW_SESSION_FROM_COACH' : {
        'title': 'Nueva sesión',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'NEW_SESSION_FROM_CLIENT' : {
        'title': 'Nueva sesión',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'ASSIGNMENT_RESOURCE' : {
        'title': 'Nuevo recurso asignado',
        'icon' : iconUser,
        'btn_text': 'Ver más'
    },
    'DAY_MEMORANDUM': {
        'title': 'Memorándum del día',
        'icon' : iconUser,
        'btn_text': 'Ver detalle'
    }
};
    
    